let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7s7Iy")).then(() => parcelRequire('3AVFN'));